/* eslint-disable */
export enum LicenseTypes {
  Nacional = 0,
  Madrid = 1,
  PaisVasco = 2,
  Extremadura = 3,
  Mexico = 4,
  Colombia = 21,
  Panama = 22,
  ArgentinaCaba = 33,
  ArgentinaPBA = 34,
  ArgentinaCordoba = 35,
  ArgentinaMendoza = 36,
}

/* eslint-disable */
export enum TransactionTypes {
  Deposit = "Deposit",
  Withdrawal = "Withdrawal",
}

export enum Licenses {
  Madrid = "Madrid",
  Nacional = "Nacional",
}

export enum IdentificationDocumentTypes {
  ID = 754310000,
  LD = 754310001,
  PA = 754310002,
  OT = 754310003,
  SS = 754310004,
  DNI = 754310005,
  NIE = 754310006,
}

export enum GameTypes {
  Slots = "slots",
  Casino = "casino",
  VideoBingo = "bingo",
  Jackpot = "jackpot",
}

export enum BannersLibraries {
  SlotsMobile = "bannersslots",
  SlotsPC = "bannersslotsPC",
  CasinoMobile = "bannerscasino",
  CasinoPC = "bannerscasinoPC",
  VideoBingoMobile = "BannersVideoBingo",
  VideoBingoPC = "BannersVideoBingoPC",
}

export enum EventsSortMethods {
  None = 0,
  Default = 1,
}

export enum ValidationPatterns {
  NameSurname = "^[a-zA-ZÀ-ÖØ-öø-ÿ][a-zA-ZÀ-ÖØ-öø-ÿ\\s\\-]*[a-zA-ZÀ-ÖØ-öø-ÿ]$",
  NotStartsOrEndsWithBlank = "^\\S.*\\S$",
}

export enum DeviceType {
  PC = "pc",
  Cordova = "cordova",
  Mobile = "mobile",
}

export enum BankTransferForm {
  TCobIban = "TCobIban",
  TCobTC = "TCobTC",
  swift_bic = "swift_bic",
}

export enum VerificationTypes {
  DNI = "DNI",
  BankReceipt = "JustificanteBancario",
  Others = "otros",
}

export enum VerificationStatus {
  Rejected = 754310000,
  Verified = 754310001,
  Pending = 1,
  Requested = 754310002,
  Inactive = 2,
}

export enum VerificationStringStatus {
  Rejected = "754310000",
  Verified = "754310001",
  Pending = "1",
  Requested = "754310002",
  Inactive = "2",
  Other = "754310003",
}

export enum VerificationTextColorClass {
  Rejected = "rejected",
  Verified = "verified",
  Pending = "pending",
  Requested = "requested",
  Inactive = "inactive",
}

export enum VeridasAttemptStatus {
  Rejected = "REJECTED",
  Pending = "PENDING",
}

export enum VerificationDocumentType {
  idFront = "idFront",
  idReverse = "idReverse",
  idSelfie = "selfie",
  idBank = "bank",
  idOther = "other",
  titleCardFront = "front",
  titleCardReverse = "reverse",
}

export enum SectionStep {
  first = 1,
  second = 2,
  third = 3,
}

export enum TrackingEventEnum {
  AccessToCashierWithdrawal = "AccessToCashierWithdrawal",
  CashierDeleteLocalWithdrawal = "CashierDeleteLocalWithdrawal",
  NotDocumentationVerifiedOnCharge = "NotDocumentationVerifiedOnCharge",
  CashierWithdrawalOk = "CashierWithdrawalOk",
  TransactionActionResultError = "TransactionActionResultError",
  CashierDeposit = "CashierDeposit",
  AccessToCashiertHistory = "AccessToCashiertHistory",
}

export enum EstadoCivilAR {
  casado = "Casado/a",
  divorciado = "Divorciado/a",
  soltero = "Soltero/a",
  unionCivil = "Unión Civil",
  unionDeHecho = "Unión de Hecho",
  viudo = "Viudo/a",
}

export enum Section {
  deposit = "deposit",
  documents = "documents",
  user = "user",
  sportBook = "sportbook",
  history = "history",
  withdrawals = "withdrawals",
}

export enum HistoryItem {
  reference = "Referencia",
  type = "Tipo",
  transactionCode = "CodigoTransacion",
  method = "Metodo",
  amount = "Cantidad",
  taxAmount = "CantidadImpuestos",
  netAmount = "CantidadNeta",
  retainedAmount = "RetainedAmount",
  account = "Cuenta",
  status = "Estado",
  taxRate = "TaxRate",
  date = "Fecha",
}

export enum parseTypeEnum {
  currency = "currency",
  date = "date",
}

export enum InputType {
  file = "file",
}

export enum InputFilesAccepted {
  images = "image/*",
}

export enum ResidencyType {
  residentDNI = "ResidenteDNI",
  residentNIE = "ResidenteNIE",
}

export enum StorageItem {
  IS_IOS_WORKAROUND = "IS_IOS_WORKAROUND",
}

export enum SVGIconVerifButton {
  Rejected = "icon-verification-button-rejected.svg",
  Completed = "icon-verification-button-completed.svg",
  Requested = "icon-verification-button-requested.svg",
  Pending = "icon-verification-button-pending.svg",
  Inactive = "icon-verification-button-inactive.svg",
}

export enum DocumentSideOption {
  Front = "Frontal",
  Reverse = "Trasero",
  DNI = "DNI",
}

export enum PaymentsCommonErrorCodes {
  GENERIC_ERROR = 131,
  GENERIC_ERROR_STRING = "error131",
  MUST_COMPLETE_DOC_VERIFICATION = 174,
  LIMIT_NOT_VERIFIED_SURPASSED = 2212,
  DEPOSIT_CANNOT_PROCEED_WITHOUT_PHONE_NUMBER = 2213,
  NO_DEPOSIT_AVAILABLE_WITH_CREDIT_CARD = 2216,
  CANNOT_WITHDRAW_UNTIL_BET_MINIMUM = 2405,
  MUST_FILL_PROFESSION_ON_VERIFICATION = 2412,
  PAYPAL_DEPOSIT_REJECTED_EMAIL_NOT_COINCIDENT = 2413,
}

export enum verificationStatuses {
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
}
